import { TimeOffRequest } from '../types/time-off-request';
import { TimeOffRequestDetails } from '../types/time-off-request-details';

/**
 * Reconstructs a `TimeOffRequest` (the list/approvals shape) from
 * `TimeOffRequestDetails`. Used by approve mode when the page is reached without
 * router state (e.g. a hard refresh of `/time-off/approvals/:requestId`): the
 * `ReviewTimeOffModal` and `useCurrentApproverDecision` operate on
 * `TimeOffRequest`, and `TimeOffRequestDetails` is a superset of its fields.
 */
export const mapDetailsToRequest = (details: TimeOffRequestDetails): TimeOffRequest => ({
  id: details.id,
  type: details.type,
  status: details.status,
  startDate: details.startDate,
  endDate: details.endDate,
  totalDays: details.totalDays,
  days: details.days,
  partOfDay: details.partOfDay,
  approvers: details.approvers,
  requestedBy: details.requestedBy,
  timeCategory: details.timeCategory,
  description: details.description,
  allowedActions: details.allowedActions,
  requestedAt: details.requestedAt,
  approvedAt: details.approvedAt,
});
